.scrollbar {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: calc(#{spacing(24)} + 3px);
  align-items: flex-end;
  margin-bottom: spacing(12);
  position: relative;
}

.scrollbar-step,
.scrollbar-step-active {
  padding: 0;
  height: 6px;
  flex: 1;
  border-radius: radius(max);
}

.scrollbar-step {
  width: 100%;
}

.scrollbar-step-active {
  position: absolute;
  background-color: c(titanium);
  transition: 400ms ease;
}

.controls {
  display: flex;
  flex-direction: row;
  @include font(aux, xs, 600);
  text-transform: uppercase;

  padding-top: spacing(16);

  @include media-breakpoint-up(md) {
    padding-top: spacing(32);
  }

  @include media-breakpoint-up(lg) {
    padding-top: spacing(48);
  }
}

.controls-left {
  flex: 1;
  padding-right: spacing(40);
}

.buttons {
  display: flex;
  flex-direction: row;
}

.counter {
  @include font(aux, xs, 600);
}

.variant-white {
  .scrollbar-step {
    background-color: c(neutral10);
  }
}

.variant-gray {
  .scrollbar-step {
    background-color: c(neutral10);
  }
}

.variant-titanium {
  .scrollbar-step {
    background-color: c("white");
    opacity: 0.1;
  }

  .scrollbar-step-active {
    background-color: c("white");
  }

  .counter {
    color: c("white");
  }
}

@media print {
  .controls,
  .buttons,
  .scrollbar {
    display: none;
  }
}
